import React from "react";

const AdminTiers: React.FC = () => {
  return (
    <div className="basic-screen-container">
      <span className="comming-soon">{"Tiers"}</span>
    </div>
  );
};

export default AdminTiers;
